const InitialState = { events: [], group: {}, select: {}, attr: {}, totalLayer: 0, loading: true, text: '' }

enum TypesFields {
    array = 'java.lang.Iterable',
    boolean = 'java.lang.Boolean',
    map = 'java.util.Map',
    number = 'java.lang.Double',
    object = 'java.lang.Object',
    string = 'java.lang.String'
}

export const reducer: WidgetReducerType<ChartState, ChartMessage> = (state = InitialState, message) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    const { type, layer, events } = message
    switch (type) {
        case 'start':
            const { group, select, fields } = events
            const selectAux = select.reduce((s, e) => (e !== 'timestamp' ? [...s, e] : s), [])

            const isAttr = (field: string) => field.startsWith('__')
            const isChartValue = (field: string) => field != 'timestamp' && !isAttr(field)

            return {
                group: group,
                select: selectAux,
                attr: {
                    ...state.attr,
                    [layer]: Object.entries(fields).reduce((s, f) => (isAttr(f[0]) ? [...s, f[0]] : s), []) as string[]
                },
                events: {
                    ...state.events,
                    [layer]: []
                },
                totalLayer: state.totalLayer < layer ? layer : state.totalLayer
            }

        case 'event':
            let atrr = {}
            events.forEach(eventGroup => {
                Object.keys(eventGroup).forEach(eventName => {
                    if (eventName.startsWith('__')) {
                        atrr = { ...atrr, [eventName]: eventGroup[eventName] }
                    }
                })
            })

            const {
                __backgroundColor: backgroundColor = '#d2d2d2',
                __fontColor: fontColor = null,
                __color: color = null,
                __text: text,
                __max: max = 100,
                __totalName: totalName = 'Total'
            } = atrr

            // chart.series[0].update({ name: select[0] }, false)
            const value = Math.round(events[0][state?.select[0]])
            const percentValue = (value / max) * 100
            console.log('percentValue', percentValue)

            return {
                ...state,
                percentValue: percentValue,
                value: value,
                options: {
                    backgroundColor,
                    fontColor,
                    text,
                    max,
                    totalName
                }
            }
        case 'endHistory':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
